import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const TrainSeat = t0 => {
  const $ = _c(12);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M9 6.21739V1.78261C9 1.43478 9.19987 1 9.99987 1H14C14.8 1 15 1.43478 15 1.78261V6.21739C15 6.84348 14.3333 7 14 7H10C9.2 7 9 6.47826 9 6.21739Z" strokeLinecap="round" />;
    t2 = <path d="M9 5.71429L11.1176 4L12.1765 4.85714L12.8824 4.28571L15 6" strokeLinecap="round" />;
    t3 = <path d="M2.00049 3.2729C2.00049 2.40018 3.06715 1.93957 3.60047 1.81836H4.00047V5.81836V8.72745C4.00047 8.96987 4.16047 9.45472 4.80046 9.45472H10.4004C10.9337 9.45472 12.0004 9.74563 12.0004 10.9093V11.6365C12.0004 12.8002 10.9337 13.0911 10.4004 13.0911H3.60047C2.32049 13.0911 2.00049 12.3638 2.00049 12.0002V3.2729Z" strokeLinecap="round" />;
    t4 = <path d="M4 8.72729V10.1818V10.5455C4 10.7879 4.16 11.2727 4.79999 11.2727C5.43999 11.2727 9.59995 11.2727 11.5999 11.2727" strokeLinecap="round" />;
    t5 = <path d="M4 1.82044H4.95999C5.43999 1.82044 6.39998 1.76846 6.39998 2.18404C6.39998 2.59963 6.39998 4.12343 6.39998 4.72949C6.39998 5.33555 6.11198 5.4568 4.95999 5.4568H4" strokeLinecap="round" />;
    t6 = <path d="M4.7998 13.0908V14.5454M7.99978 13.0908V14.5454" strokeLinecap="round" />;
    t7 = <path d="M2.00049 15.9998C2.00049 15.6362 2.24049 14.9089 3.20048 14.9089C4.16047 14.9089 7.86711 14.9089 9.60042 14.9089C10.0004 14.9089 10.8004 15.1271 10.8004 15.9998" strokeLinecap="round" />;
    t8 = <path d="M1 16L14 16" strokeLinecap="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== props) {
    t9 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16" strokeWidth={0.9}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</IconWrapper>;
    $[10] = props;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};
export { TrainSeat };